"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _styledComponents = require("styled-components");
var _actions = require("../../../actions");
var _types = require("../../../actions/types");
var _style = require("./style");
var _dsIcons = require("@olxbr/ds-icons");
var _adUtil = require("../../../helpers/adUtil");
var _selectors = require("../../../selectors");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MessageInputLock = /*#__PURE__*/function (_Component) {
  function MessageInputLock(props) {
    var _this;
    _classCallCheck(this, MessageInputLock);
    _this = _callSuper(this, MessageInputLock, [props]);
    _defineProperty(_this, "text", null);
    _defineProperty(_this, "icon", null);
    _this.text = MessageInputLock.getLockText(props);
    return _this;
  }
  _inherits(MessageInputLock, _Component);
  return _createClass(MessageInputLock, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var wasLocked = this.props.lock;
      var lock = nextProps.lock;
      if (wasLocked && !lock) {
        this.text = MessageInputLock.getLockText(this.props);
      } else {
        this.text = MessageInputLock.getLockText(nextProps);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var lock = this.props.lock;
      if (!lock) return null;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.IconWrapper, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.AlertTriangle, {
            color: "var(--color-neutral-110)",
            size: "25"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Alert, {
          children: this.text
        })]
      });
    }
  }], [{
    key: "getLockText",
    value: function getLockText(_ref) {
      var _ref$reason = _ref.reason,
        reason = _ref$reason === void 0 ? '' : _ref$reason,
        adStatus = _ref.adStatus,
        isSeller = _ref.isSeller;
      var DENOUNCED = _types.PARTNERS_STATUS.DENOUNCED,
        BLOCKED = _types.PARTNERS_STATUS.BLOCKED;
      if (!isSeller && (0, _adUtil.isAdInactive)(adStatus)) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.AlertText, {
          children: "N\xE3o \xE9 poss\xEDvel continuar esta conversa porque o an\xFAncio n\xE3o est\xE1 mais ativo."
        });
      }
      if (isSeller && (0, _adUtil.isAdDeleted)(adStatus)) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.AlertText, {
          children: "N\xE3o \xE9 poss\xEDvel continuar esta conversa porque o seu an\xFAncio foi exclu\xEDdo."
        });
      }
      if (isSeller && (0, _adUtil.isAdExpired)(adStatus)) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.AlertText, {
          children: "Seu an\xFAncio expirou. Caso queira continuar a negociar, voc\xEA pode renov\xE1-lo."
        });
      }
      if (reason === DENOUNCED) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.AlertText, {
          children: "Voc\xEA denunciou este usu\xE1rio e, para sua seguran\xE7a, ele foi bloqueado. Se ainda quiser conversar com ele, voc\xEA pode desbloque\xE1-lo."
        });
      }
      if (reason === BLOCKED) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.AlertText, {
            children: "Voc\xEA bloqueou este usu\xE1rio. Se ainda quiser conversar com ele, voc\xEA pode desbloque\xE1-lo."
          })
        });
      }
      return null;
    }
  }]);
}(_react.Component);
var mapStateToProps = function mapStateToProps(state) {
  var _getCurrentChat = (0, _selectors.getCurrentChat)(state),
    adStatus = _getCurrentChat.adStatus;
  var isSeller = (0, _selectors.amISeller)(state);
  var partnerStatus = (0, _selectors.getCurrentPartnerStatus)(state);
  return {
    reason: partnerStatus,
    adStatus: adStatus,
    isSeller: isSeller
  };
};
MessageInputLock.propTypes = {
  lock: _propTypes.bool.isRequired
};
var _default = exports["default"] = (0, _actions.connect)(mapStateToProps)((0, _styledComponents.withTheme)(MessageInputLock));